import { IOrganizationStep2FormResultModel } from '../../components/registration/organization/step2/organizationStep2FormModel';

export interface IUserModel {
    id: string;
    firstname: string;
    lastname: string;
    email: string;
    lng: string;
    comment: string;
    locations: string;
}

export const userModelFromFormData = (formData: IOrganizationStep2FormResultModel): IUserModel => {
    return {
        firstname: formData.form_organization_step_2_field_first_name,
        lastname: formData.form_organization_step_2_field_last_name,
        lng: formData.form_organization_step_2_field_correspondence_lang ? 'en' : 'fr',
    } as IUserModel;
};
